module.exports = __webpack_public_path__ + "img/fail.f1b3277e.png";